import React from 'react';

export const ArrowUpRightFromSquareIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <g fill="currentColor">
      <path d="M9.709 13.03H3.575a1.912 1.912 0 0 1-1.909-1.907V4.998c0-1.05.858-1.908 1.909-1.908h2.889a.44.44 0 0 1 .438.438.44.44 0 0 1-.438.437H3.575a1.03 1.03 0 0 0-1.033 1.033v6.125a1.03 1.03 0 0 0 1.033 1.032h6.134a1.03 1.03 0 0 0 1.033-1.032V8.24a.44.44 0 0 1 .438-.437.44.44 0 0 1 .437.437v2.882c0 1.05-.858 1.907-1.908 1.907Z" />
      <path d="M7.497 7.635a.433.433 0 0 1-.31-.129.44.44 0 0 1 0-.618l5.4-5.396a.44.44 0 0 1 .618 0c.169.17.169.45 0 .618L7.806 7.506a.433.433 0 0 1-.31.129Z" />
      <path d="M12.896 6.118a.44.44 0 0 1-.438-.438V2.24H9.014a.44.44 0 0 1-.437-.438.44.44 0 0 1 .437-.437h3.882a.44.44 0 0 1 .437.437v3.88a.44.44 0 0 1-.438.437Z" />
    </g>
  </svg>
);
